import { useRef, useState } from "react";
import "@builder/components/general/SelectInput/style.scss";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import classNames from "classnames";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

interface SelectInputProps {
    title?: string;
    value?: string;
    layout?: "row" | "column";
    className?: string;
    fonts: Record<string, string>;
    callback: (value: string) => void;
}

const SelectInputFonts: React.FC<SelectInputProps> = ({ title, value, layout = "row", className, fonts, callback }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const selectRef = useRef<HTMLInputElement>(null);

    console.log(fonts);

    useOutsideClick(selectRef, () => {
        setIsOpen(false);
    });

    const selectOption = (e: React.MouseEvent) => {
        const value = e.currentTarget.getAttribute("data-value");
        if (typeof value === "string") {
            callback(value);
            setIsOpen(false);
        }
    };

    const selectWrapperClass = classNames("select-input-wrapper", {
        ["layout-row"]: layout === "row",
        ["layout-column"]: layout === "column",
        [`${className}`]: className
    });

    return (
        <div className={selectWrapperClass}>
            {title && <OliverText text={t("generalComponents.selectInputFonts." + title)} size="xs" />}
            <div className={["select-wrapper", isOpen && "select-active"].filter(Boolean).join(" ")} ref={selectRef}>
                <img src="/angled-arrow-down.svg" />
                <input type="text" value={(typeof value === "string" && fonts[value]) || ""} readOnly onClick={() => setIsOpen(!isOpen)} />
                {isOpen && (
                    <div className="select-input-options">
                        {Object.entries(fonts).map(([value, label], index) => (
                            <div
                                className="select-input-option"
                                style={{ fontFamily: `${value}, Poppins` }}
                                key={index}
                                data-value={value}
                                onClick={selectOption}
                            >
                                {label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectInputFonts;
